import { useTexte } from '../../texte'
import type { CollageStyle } from '../../lib/collage'

/**
 * The controls of a collage's style (1.168.0): layout, corners, gap and its
 * colour. One component for the sheet and for the defaults in the
 * administration, so both offer the same steps and the same words.
 *
 * `layouts` is the list the server allows for the current number of photos;
 * without it (the administration, where there are no photos) the layout is
 * not offered -- the default per number is the server's.
 */
export function CollageStyleFields({
  style,
  bounds,
  layouts,
  onChange,
}: {
  style: CollageStyle
  bounds: { radius: number; gap: number }
  layouts?: string[]
  onChange: (style: CollageStyle) => void
}) {
  const t = useTexte()
  const words = t.chat.collage

  return (
    <div className="collagewahl">
      {layouts !== undefined && layouts.length > 1 && (
        <fieldset className="collagewahl__aufteilung">
          <legend className="field__label">{words.aufteilung}</legend>
          <div className="collagewahl__knoepfe" role="radiogroup" aria-label={words.aufteilung}>
            {layouts.map((layout) => (
              <button
                key={layout}
                type="button"
                role="radio"
                aria-checked={style.layout === layout}
                className={style.layout === layout ? 'button button--small' : 'button button--outline button--small'}
                data-layout={layout}
                onClick={() => onChange({ ...style, layout })}
              >
                {words.layout[layout] ?? layout}
              </button>
            ))}
          </div>
        </fieldset>
      )}
      <label className="field field--luft">
        <span className="field__label">{words.ecken}</span>
        <span className="collagewahl__regler">
          <input
            type="range"
            name="collage_radius"
            min={0}
            max={bounds.radius}
            value={style.radius}
            onChange={(event) => onChange({ ...style, radius: Number(event.target.value) })}
          />
          <span className="collagewahl__zahl">{words.punkte(style.radius)}</span>
        </span>
      </label>
      <label className="field field--luft">
        <span className="field__label">{words.steg}</span>
        <span className="collagewahl__regler">
          <input
            type="range"
            name="collage_gap"
            min={0}
            max={bounds.gap}
            value={style.gap}
            onChange={(event) => onChange({ ...style, gap: Number(event.target.value) })}
          />
          <span className="collagewahl__zahl">{words.punkte(style.gap)}</span>
        </span>
      </label>
      <label className="field field--luft">
        <span className="field__label">{words.stegfarbe}</span>
        {/* The native colour field: on the iPad it opens the system's
            picker, as for the button colour. */}
        <input
          type="color"
          className="kartenregler__farbe"
          name="collage_color"
          value={style.color}
          onChange={(event) => onChange({ ...style, color: event.target.value })}
        />
      </label>
    </div>
  )
}
